import React from 'react';
import { APPLE_PAY_EMAIL } from '../../utils/Constants';
import {
  fanButtonArray,
  payLinkButtonArray,
  socialLinkButtonArray,
  linkHubButtonArray,
} from '../../utils/data/LinksData';

function LinksPageMainContainer() {
  // Re-use the same colour cycle as your CTA
  const borderClasses = [
    'border-colour6',
    'border-colour7',
    'border-colour8',
    'border-colour5',
  ];

  return (
    <main role='main' className='grid pt-6'>
      {/* Page kicker */}
      <article className='grid text-center px-6 sm:py-4 lg:py-8 gap-3'>
        <h3 className='text-3xl md:text-5xl md:mb-2 font-titleFont neon_text_thin_magenta_pink leading-[3rem]'>
          Show Your Devotion
        </h3>
      </article>

      {/* PAYMENTS & TRIBUTES */}
      <section className='grid gap-y-4 pt-8'>
        <header className='grid place-items-center gap-2 px-6'>
          <h4 className='font-titleFont text-2xl md:text-3xl neon_text_thin_magenta tracking-widest drop-shadow-lg text-center'>
            PAYMENTS & TRIBUTES
          </h4>
          <div className='neon_line' />
        </header>

        <div className='grid justify-center mx-auto gap-y-4 w-fit'>
          {payLinkButtonArray.map((btn, index) => (
            <a
              key={index}
              href={btn.link || '#'}
              className={`grid grid-cols-[auto_1fr] items-center gap-3 cursor-pointer neon_button border-2 border-solid ${
                borderClasses[index % borderClasses.length]
              } px-6 py-2 w-full text-center rounded bg-colour2 hover:shadow-cardShadowBold transition`}
              aria-label={`Visit ${btn.text}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='text-2xl'>{btn.icon}</span>
              <span className='text-center w-full'>{btn.text}</span>
            </a>
          ))}
        </div>

        {/* Static payment notes */}
        <div className='grid px-6 pt-4 gap-2 text-center text-sm opacity-80'>
          <p>
            <strong>Apple Pay:</strong>{' '}
            <span className='font-mono'>{APPLE_PAY_EMAIL}</span> — this will
            open your email client to arrange tribute directly.
          </p>
          <p>
            <strong>PayPal:</strong> available <em>by request only</em>.
          </p>
        </div>
      </section>

      {/* FANSITES / BOOKING */}
      <section className='grid gap-y-4 pt-12'>
        <header className='grid place-items-center gap-2'>
          <h4 className='font-titleFont text-2xl md:text-3xl neon_text_thin_magenta_pink tracking-widest drop-shadow-lg text-center'>
            FANSITES & BOOKING
          </h4>
          <div className='neon_line' />
        </header>

        <div className='grid justify-center mx-auto gap-y-4 w-fit'>
          {fanButtonArray.map((btn, index) => (
            <a
              key={index}
              href={btn.link || '#'}
              className={`grid grid-cols-[auto_1fr] items-center gap-3 cursor-pointer neon_button border-2 border-solid ${
                borderClasses[index % borderClasses.length]
              } px-6 py-2 w-full text-center rounded bg-colour2 hover:shadow-cardShadowBold transition`}
              aria-label={`Visit ${btn.text}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='text-2xl'>{btn.icon}</span>
              <span className='text-center w-full'>{btn.text}</span>
            </a>
          ))}
        </div>
      </section>

      {/* LINK HUB (msha.ke at the end) */}
      <section className='grid gap-y-4 pt-10 pb-10'>
        <header className='grid place-items-center gap-2'>
          <h4 className='font-titleFont text-2xl md:text-3xl neon_text_thin_magenta tracking-widest drop-shadow-lg text-center'>
            FULL LINK HUB
          </h4>
          <div className='neon_line' />
        </header>

        <div className='grid justify-center mx-auto gap-y-4 w-fit'>
          {linkHubButtonArray.map((btn, index) => (
            <a
              key={index}
              href={btn.link || '#'}
              className={`grid grid-cols-[auto_1fr] items-center gap-3 cursor-pointer neon_button border-2 border-solid ${
                borderClasses[index % borderClasses.length]
              } px-6 py-2 w-full text-center rounded bg-colour2 hover:shadow-cardShadowBold transition`}
              aria-label={`Visit ${btn.text}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='text-2xl'>{btn.icon}</span>
              <span className='text-center w-full'>{btn.text}</span>
            </a>
          ))}
        </div>
      </section>

      {/* SOCIAL */}
      <section className='grid gap-y-4 pt-12'>
        <header className='grid place-items-center gap-2'>
          <h4 className='font-titleFont text-2xl md:text-3xl neon_text_thin_violet tracking-widest drop-shadow-lg text-center'>
            SOCIAL & CONTACT
          </h4>
          <div className='neon_line' />
        </header>

        <div className='grid justify-center mx-auto gap-y-4 w-fit'>
          {socialLinkButtonArray.map((btn, index) => (
            <a
              key={index}
              href={btn.link || '#'}
              className={`grid grid-cols-[auto_1fr] items-center gap-3 cursor-pointer neon_button border-2 border-solid ${
                borderClasses[index % borderClasses.length]
              } px-6 py-2 w-full text-center rounded bg-colour2 hover:shadow-cardShadowBold transition`}
              aria-label={`Visit ${btn.text}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='text-2xl'>{btn.icon}</span>
              <span className='text-center w-full'>{btn.text}</span>
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}

export default LinksPageMainContainer;
